import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useApi, useFetch } from '@hooks';
import { useSaveServiceResponse } from '@store';
import {
	ContentsClientCookiesInputDto,
	ContentsClientCookiesOutputDto,
	ContentsClientCookiesOutputDtoSingleOutputMessage,
} from '@types';

export const useFetchContentsClientCookies = (): UseFetchHookOutput<
	ContentsClientCookiesInputDto,
	ContentsClientCookiesOutputDto
> => {
	const { contentsClientCookies: fetchContentsClientCookies } = useApi();
	const saveServiceResponse = useSaveServiceResponse();

	return useFetch<ContentsClientCookiesInputDto, ContentsClientCookiesOutputDto>({
		input: {
			fetchFn: fetchContentsClientCookies,
			onSuccess: (res: ContentsClientCookiesOutputDtoSingleOutputMessage) => {
				saveServiceResponse({ contentsClientCookies: res.data });
			},
		},
		requestName: 'contents/client/cookies',
		showGenericErrorModal: false,
		showGlobalLoader: false,
		showLoggerOverlay: false,
	});
};
